import './styles/styles.css';
import { bootstrap } from './app/bootstrap';
import { q } from './shared/dom';

void bootstrap(q('#app'));
